import { BRAND } from "../../data/content";
import { Container, scrollToHash } from "./ui";

const COLS = [
  {
    title: "SERVICES",
    links: [
      { label: "Résidence & propriété", hash: "#residence" },
      { label: "Services corporate", hash: "#corporate" },
      { label: "Conciergerie privée", hash: "#prive" },
      { label: "Travel Desk", hash: "#travel" },
      { label: "Aviation privée", hash: "#aviation" },
      { label: "Mobilité", hash: "#services" },
      { label: "Demandes exceptionnelles", hash: "#demande" },
    ],
  },
  {
    title: "SOCIÉTÉ",
    links: [
      { label: "À propos", hash: "#approche" },
      { label: "Notre réseau", hash: "#network" },
      { label: "Contact", hash: "#demande" },
      { label: "Mentions légales", hash: "#top" },
      { label: "Confidentialité", hash: "#top" },
    ],
  },
];

const Footer = () => (
  <footer className="border-t border-[#1c1c1c] bg-coal" data-testid="footer">
    <Container className="py-16 md:py-20">
      <div className="grid gap-12 md:grid-cols-12">
        <div className="md:col-span-4">
          <img
            src="/logo-navbar.png"
            alt="INVOGUE — Private & Corporate Concierge"
            className="h-10 w-auto"
          />
          <p className="mt-6 font-serif text-xl italic text-neutral-400">
            Une demande. Une solution.
          </p>
        </div>

        {COLS.map((col) => (
          <div key={col.title} className="md:col-span-2">
            <p className="font-display text-[10px] font-semibold tracking-[0.22em] text-muted">
              {col.title}
            </p>
            <ul className="mt-5 space-y-3">
              {col.links.map((l) => (
                <li key={l.label}>
                  <a
                    href={l.hash}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToHash(l.hash);
                    }}
                    className="font-sans text-[13px] font-light text-neutral-400 transition-colors duration-300 hover:text-champagne"
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-zà-ÿ]+/g, "-")}`}
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}

        <div className="md:col-span-4">
          <p className="font-display text-[10px] font-semibold tracking-[0.22em] text-muted">
            CONTACT
          </p>
          <a
            href={`mailto:${BRAND.email}`}
            className="mt-5 block font-sans text-[13px] font-light text-neutral-300 transition-colors hover:text-champagne"
            data-testid="footer-email"
          >
            {BRAND.email}
          </a>
          <a
            href={`tel:${BRAND.phoneTel}`}
            className="mt-3 block font-sans text-[13px] font-light text-neutral-300 transition-colors hover:text-champagne"
            data-testid="footer-phone"
          >
            {BRAND.phone}
          </a>
          <button
            onClick={() => scrollToHash("#demande")}
            className="mt-7 inline-block border border-champagne/50 px-6 py-3 font-display text-[10px] font-semibold tracking-[0.16em] text-champagne uppercase transition-colors duration-300 hover:bg-champagne hover:text-ink"
            data-testid="footer-cta"
          >
            Faire une demande
          </button>
        </div>
      </div>

      <div className="mt-16 flex flex-col justify-between gap-3 border-t border-line pt-8 md:flex-row md:items-center">
        <p className="font-sans text-[11px] font-light text-neutral-600">
          © 2026 INVOGUE. TOUS DROITS RÉSERVÉS.
        </p>
        <p className="font-sans text-[10px] tracking-[0.18em] text-neutral-700">
          PRIVATE & CORPORATE CONCIERGE
        </p>
      </div>
    </Container>
  </footer>
);

export default Footer;
